query getCmsOrganization($companyId: ID!) {
  cmsOrganization: getCmsOrganization(companyId: $companyId) {
    id
    widgetType
  }
}
